
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/colorful-square-prints",
      function () {
        return require("private-next-pages/colorful-square-prints.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/colorful-square-prints"])
      });
    }
  